import { Button as PageButton } from '@web/components/page-components/Button'
import { type Button as ButtonProps } from '@web/graphql-components'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

const Button = (props: ButtonProps) => {
  const campaignDomain = usePageStore((state) => state.campaignDomain)
  const searchParams = useSearchParams()

  const url = useMemo(() => {
    if (!props.styles?.isInternalLink || !campaignDomain) {
      return props.url
    }

    const query = searchParams.toString() ? `?${searchParams.toString()}` : ''
    const anchor = props.styles?.options?.anchorLink ? `#${props.styles.options.anchorLink}` : ''

    return `${campaignDomain}/${props.url ?? ''}${query}${anchor}`
  }, [campaignDomain, searchParams, props.url, props.styles?.isInternalLink, props.styles?.options?.anchorLink])

  return <PageButton {...props} url={url} />
}

export default Button
